const STORAGE_KEY = "orzio.cookies.consent";

export type CookieConsentValue = "accepted" | "essential_only";

export const readCookieConsent = (): CookieConsentValue | null => {
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return raw === "accepted" || raw === "essential_only" ? raw : null;
};

export const writeCookieConsent = (value: CookieConsentValue) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, value);
};

export const hasAnalyticsConsent = () => readCookieConsent() === "accepted";
